import React from 'react';

const AboutPage = () => {
  return (
    <div className="App">

      <section className="section" style={{ backgroundColor: 'var(--light)' }}>
        <div className="container">
          <div className="section-title">
            <h2>About Nozomi Robotics</h2>
            <p>The journey, mission, and vision behind our project</p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '3rem',
            alignItems: 'start'
          }}>
            <div>
              <h3 style={{
                color: 'var(--primary)',
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>Our Mission</h3>

              <p style={{ marginBottom: '1.5rem' }}>
                Nozomi Robotics was created with a singular purpose: to strengthen people's independent
                problem-solving skills through computational thinking. As more of our world becomes
                automated and technology-driven, the ability to think computationally has emerged as
                a fundamental literacy for the 21st century.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                I believe that hands-on, tangible experiences with programming physical objects offer
                a uniquely powerful way to develop computational thinking. By building and programming
                their own robots, users create concrete representations of abstract computational concepts,
                making learning more accessible, engaging, and transferable to new domains.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Through Nozomi Robotics, I aim to democratize access to this powerful learning approach,
                making it available to students, educators, and lifelong learners regardless of their
                previous technical experience.
              </p>

              <h3 style={{
                color: 'var(--primary)',
                marginTop: '2.5rem',
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>The Inspiration</h3>

              <p style={{ marginBottom: '1.5rem' }}>
                The inspiration for Nozomi Robotics came from observing how students often struggle with
                abstract programming concepts when they lack tangible connections to the real world.
                I saw how physical computing—where code directly controls objects in the physical world—created
                powerful "aha!" moments that purely screen-based coding activities couldn't match.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                This project builds on foundations laid by pioneers like Seymour Papert, whose theory
                of constructionism emphasized learning through making, and Jeannette Wing, whose framework
                of computational thinking has reshaped how we understand these crucial problem-solving skills.
              </p>
            </div>

            <div>
              <h3 style={{
                color: 'var(--primary)',
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>Research Foundation</h3>

              {/* <p style={{ marginBottom: '1.5rem' }}>
                Nozomi Robotics is deeply informed by research on how people learn computational thinking skills.
                I've been particularly influenced by the work coming out of Stanford's Graduate School of
                Education, especially Dr. Shima Salehi's IDEAL Lab which investigates how to assess and
                develop computational thinking in diverse learning environments.
              </p> */}

              <p style={{ marginBottom: '1.5rem' }}>
                The learning challenges embedded in Nozomi Robotics are carefully structured to progressively
                develop the four core components of computational thinking: decomposition, pattern
                recognition, abstraction, and algorithmic thinking. Each challenge encourages
                learners to break down problems, identify patterns, focus on relevant information,
                and develop step-by-step solutions.
              </p>

              <h3 style={{
                color: 'var(--primary)',
                marginTop: '2.5rem',
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>Future Vision</h3>

              <p style={{ marginBottom: '1.5rem' }}>
                My vision is to continue developing Nozomi Robotics as part of my graduate studies at
                Stanford's Learning, Design, and Technology program. I'm particularly interested in
                conducting empirical research on how physical computing experiences with Nozomi Robotics
                transfer to other problem-solving domains and influence learners' computational
                identities.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                Looking ahead, I see opportunities to expand Nozomi Robotics with new sensor modules,
                machine learning capabilities, and collaborative learning features. I'm also exploring
                partnerships with schools and out-of-school learning environments to bring Nozomi Robotics
                to diverse communities of learners.
              </p>

              <p style={{ marginBottom: '1.5rem' }}>
                I invite you to join me on this journey of using robotics to empower the next
                generation of computational thinkers.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: 'white' }}>
        <div className="container">
          <div className="section-title">
            <h2>Creator's Journey</h2>
            <p>The story and aspirations behind Nozomi Robotics</p>
          </div>

          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: 'var(--light)',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <p style={{ marginBottom: '1.5rem' }}>
              Hello! I'm the creator of Nozomi Robotics, and I'm passionate about making computational thinking
              accessible to everyone through hands-on, tangible learning experiences.
            </p>

            <p style={{ marginBottom: '1.5rem' }}>
              My journey with educational technology began when I witnessed firsthand how students who
              struggled with abstract programming concepts suddenly had breakthrough moments when they
              could see their code move something in front end development. This sparked my interest in how
              robotics could be used as a bridge to computational thinking.
            </p>

            <p>
              I welcome your feedback, questions, and collaboration opportunities as I continue to develop and
              refine Nozomi Robotics.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;